import {Fragment, useEffect, useState} from "react";
///import "../../assets/css/course.css"
import '../../assets/css/single_cource/course-video.css';
import c1 from '../../components/assets/img/thumbnail.jpeg'

import * as React from "react";
import { Link,NavLink,useNavigate } from "react-router-dom";
import clientconfigwebapp, {check_login_appbk, scrollTo_uphk} from "../../clientconfigwebapp";

const Meeting_Lessons = (props) => {

    const [lock , setLock] = useState(true);

    const navigate = useNavigate();
    useEffect(() => {

//console.log(props.data_lessons)

        if(check_login_appbk()==true){
        setLock(false);
        }


    },[1]);






    return (
        <>

            {
                String(props.data_lessons).length==0 ?  (

                <>

                </>

            ) : (
                <>

                    {

                        props.data_lessons.map((child_item_get,index) => {

                            var counter_row_child=parseInt(index) + 1

                            var class_custome_bk="";


                            if(props.lesson_id==child_item_get.id_mett){  class_custome_bk=" active_item_c ";   }


                            return (
                                <Fragment>


                        <div className={"flexRowBetCenter course-item lesson-item mettings-lesson-item " + String(class_custome_bk)  } >



                                            <div className="box_lesson_box_karimain" >


                                                <Link   className="flexRowBetCenter des-lesson" reloadDocument={true}    to={"/panel/my-course/" + String(props.cource_id_get) + "/" + String(child_item_get.id_mett)}>
                                                { lock === false ?
                                                    <div className="lesson-num">{counter_row_child}</div>
                                                    :

                                                    <div className="lesson-num lock-svg">
                                                        <svg className="icon_play_list_metting" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.1374 4.51386C11.703 4.37049 12.2969 4.37049 12.8625 4.51386C14.1819 4.84832 15.1258 5.96028 15.2306 7.26587L15.1915 7.25782C13.0872 6.82413 10.9128 6.82413 8.8085 7.25782L8.76936 7.26589C8.87413 5.96028 9.81803 4.84832 11.1374 4.51386ZM16.685 7.50839V7.7184C18.1592 8.40029 19.2768 9.68843 19.6983 11.2674C20.1955 13.1297 20.0758 15.0973 19.3563 16.8896L19.2718 17.1C18.5 19.0225 16.7426 20.4054 14.6498 20.7371L13.9687 20.845C12.6648 21.0517 11.3352 21.0517 10.0313 20.845L9.35019 20.7371C7.25734 20.4054 5.49999 19.0225 4.72818 17.1L4.64368 16.8895C3.92417 15.0973 3.80447 13.1297 4.30168 11.2674C4.72321 9.68846 5.84078 8.40033 7.31494 7.71843V7.50838C7.31494 5.45953 8.7365 3.66924 10.7734 3.15292C11.5777 2.94903 12.4223 2.94903 13.2266 3.15292C15.2634 3.66924 16.685 5.45954 16.685 7.50839ZM12 12.8504C12.3192 12.8504 12.5779 13.1022 12.5779 13.4129V15.288C12.5779 15.5987 12.3192 15.8506 12 15.8506C11.6809 15.8506 11.4221 15.5987 11.4221 15.288V13.4129C11.4221 13.1022 11.6809 12.8504 12 12.8504Z" fill="#DC2626"/>
                                                        </svg>
                                                    </div>

                                                }
                                                <span>{ child_item_get.title_post }</span>


                                                {
                                                    child_item_get.clock_time=='3213213213' ?  (
                                                        <>
                                                            <div className="flexRowBetCenter">
                                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M2.79406 7.45869C3.33698 5.14417 5.14417 3.33698 7.45869 2.79406C9.13021 2.40198 10.8698 2.40198 12.5413 2.79406C14.8558 3.33698 16.663 5.14417 17.2059 7.4587C17.598 9.13021 17.598 10.8698 17.2059 12.5413C16.663 14.8558 14.8558 16.663 12.5413 17.2059C10.8698 17.598 9.13021 17.598 7.4587 17.2059C5.14418 16.663 3.33698 14.8558 2.79406 12.5413C2.40198 10.8698 2.40198 9.13021 2.79406 7.45869Z" stroke="#949494" stroke-width="1.5"/>
                                                                    <path d="M12.0833 12.0833L9.71783 10.5783V7.5" stroke="#949494" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                                </svg>
                                                                <span>{ child_item_get.clock_time}</span>
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <>

                                                        </>
                                                    )

                                                }

                                                </Link>
                                            </div>

                            <Link   reloadDocument={true}    to={"/panel/my-course/" + String(props.cource_id_get) + "/" + String(child_item_get.id_mett)}>
                                            {
                                                lock === false ?


                                                <div className="lesson-play-btn">
                                                    <svg className="icon_play_list_metting" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M5 15V10.55C5 5.02501 8.9125 2.76251 13.7 5.52501L17.5625 7.75001L21.425 9.97501C26.2125 12.7375 26.2125 17.2625 21.425 20.025L17.5625 22.25L13.7 24.475C8.9125 27.2375 5 24.975 5 19.45V15Z" fill="white" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                </div>

                                                :




                                                <div className="lesson-play-btn lesson-play-btn-locked">
                                                    <svg className="icon_play_list_metting" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M5 15V10.55C5 5.02501 8.9125 2.76251 13.7 5.52501L17.5625 7.75001L21.425 9.97501C26.2125 12.7375 26.2125 17.2625 21.425 20.025L17.5625 22.25L13.7 24.475C8.9125 27.2375 5 24.975 5 19.45V15Z" fill="white" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                </div>




                                            }
                            </Link>
                                        </div>
                                </Fragment>
                            );


                        })
                    }
                </>

            ) }







        </>
    );


}

export default Meeting_Lessons;
